import { Dispatch, SetStateAction } from 'react'
import { FieldErrors } from 'react-hook-form'
import { Trans } from '@lingui/macro'
import { MenuItem } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded'

import { PatientProfileFormData } from '@/features/patient/patient-profile-form'
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isStaff } from '@/utils/type-guards'

import { useSearchIns } from '../../model/useSearchIns'

type GetInsProps = {
  onClose?: () => void
  patientId: string
  setFormErrors: Dispatch<SetStateAction<FieldErrors<PatientProfileFormData>>>
}

export function GetIns({ onClose, patientId, setFormErrors }: GetInsProps) {
  const authUser = useAppSelector(selectAuthUser)
  const isLargeScreen = useIsLargeScreen()
  const { searchIns, isFetchingIns } = useSearchIns({ patientId, setFormErrors })

  const showInsVerification = isStaff(authUser) && authUser.managePatientPreferences.insEnabled

  if (!showInsVerification) return null

  if (isLargeScreen) {
    return (
      <LoadingButton loading={isFetchingIns} onClick={searchIns} startIcon={<PermIdentityRoundedIcon />} variant="contained">
        <Trans>Get INS</Trans>
      </LoadingButton>
    )
  }

  return (
    <MenuItem
      disableRipple
      onClick={() => {
        searchIns()
        onClose?.()
      }}
    >
      <PermIdentityRoundedIcon />
      <Trans>Get INS</Trans>
    </MenuItem>
  )
}
